"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ContentBanner1", {
  enumerable: true,
  get: function get() {
    return _contentBanner["default"];
  }
});
Object.defineProperty(exports, "ContentBanner2", {
  enumerable: true,
  get: function get() {
    return _contentBanner2["default"];
  }
});
var _contentBanner = _interopRequireDefault(require("./content-banner-1"));
var _contentBanner2 = _interopRequireDefault(require("./content-banner-2"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}